<mat-dialog-content class="dialog_content">
  <app-paragraph class="mb_30" textAlign="center">{{'peopleNew.title.DYN.' | translate}}</app-paragraph>
  <form class="mb_20 f_col gap_20 newPeople-form-container" id="form" [formGroup]="form" (ngSubmit)="submit()">
    <app-input *ngIf="api.env.personFields.indexOf('firstName') > -1"
                  formCtrlName="firstName" [formGrp]="form" class="mb_5" disabled="true" label="form.firstName"
                  icon="user" [matTooltip]="'tooltip.docFirstName' | translate"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('lastName') > -1"
              formCtrlName="lastName" [formGrp]="form" class="mb_5" disabled="true" label="form.lastName"
              icon="user" [matTooltip]="'tooltip.docLastName' | translate"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('nationalNumber') > -1"
              formCtrlName="personalNr" [formGrp]="form" class="mb_5" disabled="true" label="global.personalNr"
              icon="hashtag"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('passportNumber') > -1"
              class="mb_5" formCtrlName="passportNr" [formGrp]="form" disabled="true" label="global.passportNum"
              icon="hashtag" [matTooltip]="'tooltip.docPassportNumber' | translate"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('birthDate') > -1"
              formCtrlName="birthDate" [formGrp]="form" type="date" class="mb_5" label="form.birthDate"
              icon="calendar"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('sex') > -1"
              formCtrlName="sex" [formGrp]="form" type="select" class="mb_5" label="form.sex"
              icon="gender" [selectOptions]="sexOptions"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('birthPlaceCity') > -1"
              formCtrlName="birthPlaceCity" [formGrp]="form" class="mb_5" label="form.placeOfBirth"
              icon="location_city"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('birthPlaceCountry') > -1"
              formCtrlName="birthPlaceCountry" [formGrp]="form" type="select" class="mb_5" label="form.birthPlaceCountry" icon="flag" [selectOptions]="countriesOptions"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('linkType') > -1"
              class="mb_5" [formGrp]="form" type="select" formCtrlName="linkType"
              label="{{'form.linkType' | translate}}" icon="list" [selectOptions]="linkTypeOptions" [matTooltip]="'tooltip.docLinkType' | translate"></app-input>
    <app-input *ngIf="api.env.personFields.indexOf('linkType') > -1 && otherOptions"
              formCtrlName="otherLinkType" [formGrp]="form" class="mb_5" disabled="true"
              label="form.otherLinkType" icon="link" [matTooltip]="'tooltip.docLinkTypeOther' | translate"></app-input>
    <app-errors-list [dark]="true" *ngIf="submitted"
    [formErrors]="this.forms.getFormErrors(this.form)"></app-errors-list>
  </form>
  <div class="mt_20 flex gap_10 f_center">
    <app-button size="sm" class="dialog_close"
                (btnClicked)="closeDialog()">
      {{ 'global.close' | translate }}
    </app-button>
    <app-button size="sm" type="submit" formId="form" [disabled]="!form.get('firstName').value && !form.get('lastName').value">
      {{ 'global.confirm' | translate }}
    </app-button>
  </div>
</mat-dialog-content>
